module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('div', {
    staticClass: "gutr mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 col-sm-12 grid-margin stretch-card"
  }, [_c('div', [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-brand', {
    staticStyle: {
      "padding": "0.475rem 1rem"
    }
  }, [_c('transition', {
    attrs: {
      "name": "custom-slide",
      "mode": "out-in"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$route.name))])])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button-group', {
    staticClass: "ml-1 text-right",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "tab-list d-flex"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('div', {
      key: index,
      class: {
        'active-tab': _vm.activeTab === index
      },
      on: {
        "click": function($event) {
          _vm.changeTab(index)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(tab.name) + "\n                      ")])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "custom-slide",
      "mode": "out-in"
    }
  }, [_c(_vm.currentTabComponent, {
    key: _vm.activeTab,
    tag: "component"
  })], 1)], 1)], 1)], 1)], 1)], 1)])])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733cc3fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/Tab.vue
// module id = 2746
// module chunks = 0